/** Home is always in the main nav and default route; it is not listed in role tab permission pickers. */
export function isHomeNavTab(tab) {
  if (!tab || typeof tab !== 'object') return false;
  const name = String(tab.name || '').toLowerCase().trim();
  const label = String(tab.label || '').toLowerCase().trim();
  const url = String(tab.url || '')
    .toLowerCase()
    .trim()
    .split('?')[0];
  if (name === 'home' || label === 'home') return true;
  if (url === '/' || url === '/home') return true;
  return false;
}

export function isHomeTabName(name) {
  return String(name || '').toLowerCase().trim() === 'home';
}

/** Dispatched after user saves tab personalization so Menu refetches nav tabs. */
export const NAV_TABS_UPDATED_EVENT = 'spark_nav_tabs_updated';

export function emitNavTabsUpdated() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(NAV_TABS_UPDATED_EVENT));
  }
}
